"use client";

import React from "react";
import { NavHeaderAction, NavHeaderTheme } from "./types";
import { createButton } from "./button-factory";

interface SideActionProps {
  action?: NavHeaderAction;
  theme?: NavHeaderTheme;
}

export const SideAction: React.FC<SideActionProps> = ({ action, theme }) => {
  if (!action) {
    return null;
  }

  return <>{createButton({ action, theme })}</>;
};
